class AnnouncementBar {
  constructor(element) {
    this.$el = $(element);
    this.$closeBtn = this.$el.find('.gg-announcement__close');

    this.init();
  }

  init() {
    this.bindEvents();
    this.checkVisibility();
  }

  bindEvents() {
    this.$closeBtn.on('click', () => this.handleClose());
  }

  handleClose() {
    // Add fade out animation
    this.$el.fadeOut(300, () => {
      this.$el.remove();
    });

    // Store in sessionStorage to keep it closed during the session
    sessionStorage.setItem('announcement-closed', 'true');
  }

  checkVisibility() {
    // Check if announcement was closed in this session
    if (sessionStorage.getItem('announcement-closed') === 'true') {
      this.$el.hide();
    }
  }
}

// Initialize on document ready
$(document).ready(() => {
  $('.gg-announcement').each(function () {
    new AnnouncementBar(this);
  });
});
